<div class="demo-div">
  <div class="button-div">
    <button class="download-pdf-btn" mat-button (click)="onDownlaodPdf()">Download PDF</button>
  </div>
  <pdf-viewer 
    [src]="pdfSrc"
    [render-text]="true"
    style="display: block;"
  ></pdf-viewer>
</div>